// extracted by mini-css-extract-plugin
module.exports = {"splashStyle":"CrmIntegration_splashStyle__2m2zf"};